import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { USER_ROLES } from "@/constants/auth";
import { queryKeys } from "@/constants/queryKeys";
import { useToast } from "@/hooks/useToast";
import useAuthStore from "@/context/auth/useAuthStore";
import { services } from "@/services/registry";
export const useOrganizationSettingsQuery = ()=>{
    const { userRole } = useAuthStore();
    const isAdmin = userRole === USER_ROLES.ADMIN || userRole === USER_ROLES.SUPERADMIN;
    return useQuery({
        queryKey: queryKeys.organizations.settings(),
        queryFn: async ()=>{
            const response = await services.organizationService.getOrganizationSettings();
            return response.settings;
        },
        staleTime: 5 * 60 * 1000,
        enabled: isAdmin
    });
};
export const useUpdateOrganizationSettings = ()=>{
    const queryClient = useQueryClient();
    const toast = useToast();
    return useMutation({
        mutationFn: (settings)=>services.organizationService.updateOrganizationSettings(settings),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: queryKeys.organizations.settings()
            });
            toast.success("Organization settings updated successfully");
        },
        onError: (error)=>{
            toast.handleApiError(error, "Failed to update organization settings");
        }
    });
};
export const useOrganizationSettings = ()=>{
    const settingsQuery = useOrganizationSettingsQuery();
    const updateSettingsMutation = useUpdateOrganizationSettings();
    return {
        settings: settingsQuery.data || {
            enforce2FA: false
        },
        isLoading: settingsQuery.isLoading,
        error: settingsQuery.error,
        refetch: settingsQuery.refetch,
        updateSettings: updateSettingsMutation.mutateAsync,
        isUpdating: updateSettingsMutation.isPending,
        updateError: updateSettingsMutation.error
    };
};
